/**
 * FeedbackData.tsx — Analytics / Feedback Data page.
 *
 * The only feedback endpoint (/v1/analytics/feedback-export) is operator-scoped,
 * not tenant-facing, so this view shows an honest "coming soon" state rather
 * than fabricated feedback rows.
 */
import { SectionTitle, ComingSoon } from '../DashboardShared'

export function FeedbackData() {
  return (
    <div className="page-enter flex flex-col gap-5">
      <SectionTitle title="Feedback Data" subtitle="Human-reviewed run outputs and quality annotations" />
      <ComingSoon
        module="Feedback"
        description="Per-tenant run feedback is not yet exposed on the tenant API. Once the feedback endpoint is available, reviewed outputs will appear here."
      />
    </div>
  )
}
